<template>
    <div class="registry-wrapper">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="columns">
            <div
                class="column"
                :class="[
                    permissaoVincular && permissaoCadastrar
                        ? 'is-4'
                        : permissaoVincular || permissaoCadastrar
                        ? 'is-6'
                        : 'is-8',
                ]"
            >
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-campo-busca-tabela-preco"
                />
            </div>
            <div
                class="column"
                :class="[
                    permissaoVincular && permissaoCadastrar
                        ? 'is-2'
                        : permissaoVincular || permissaoCadastrar
                        ? 'is-3'
                        : 'is-4',
                ]"
            >
                <vss-select
                    ref="situacaoSelect"
                    :searchable="false"
                    :options="situacaoSelect"
                    v-model="situacaoSelected"
                    mlLabels
                    title="situacao"
                    clearable
                    @input="onSituacaoChanged"
                    :height="40"
                />
            </div>
            <div class="column is-3" v-if="permissaoVincular">
                <button class="save-btn botao-acao" type="button" @click="showModal = !showModal">
                    {{ $t('vincular-tabela-preco') }}
                </button>
            </div>
            <!-- Botao vai para a tela de cadastro de tabela preço -->
            <div class="column is-3" v-if="permissaoCadastrar">
                <button
                    class="save-btn botao-acao"
                    type="button"
                    @click="
                        $router.push({
                            name: `${abrev}-tabelapreco-new`,
                            query: {
                                tela: `${abrev}-cliente-tabela-preco`,
                                id: $route.params.id,
                                dadoscadastrais: $route.query.dadoscadastrais
                                    ? $route.query.dadoscadastrais
                                    : null,
                                politicacomercial: 3,
                                analisecomercial: $route.query.analisecomercial
                                    ? $route.query.analisecomercial
                                    : null,
                                contexto: isVenda ? 'ven' : 'agro',
                            },
                        })
                    "
                >
                    {{ $t('adicionar-tabela-preco') }}
                </button>
            </div>
        </div>
        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="asstabprecoclientelist"
                class="data-table"
                @sort="sortTable"
                backend-sorting
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                    :width="f.width"
                    :class="{
                        'excluir-field': f.key == 'excluir',
                    }"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <div v-if="f.key == 'excluir'">
                        <b-button
                            v-if="permissao.update && !assTabPrecoClienteIntegracao"
                            class="action-button"
                            :type="props.row['replicapda'] == 3 ? 'is-danger' : 'is-success'"
                            :icon-right="props.row['replicapda'] == 3 ? 'delete' : 'check'"
                            @click="promptChangeSituacao(props.row)"
                            v-tippy
                            :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                        />
                        <b-tag
                            v-else
                            class="table-tag table-tag-full-width"
                            :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                            size="is-medium"
                            >{{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}</b-tag
                        >
                    </div>
                    <div v-else-if="f.key == 'reajusteciffob'">
                        {{ $t(props.row[f.key] == 1 ? 'sim' : 'nao') }}
                    </div>
                    <div v-else-if="f.key == 'datavalidade'">
                        {{ props.row[f.key] | moment('DD/MM/YYYY') }}
                    </div>
                    <div v-else-if="f.key == 'replicapda'">
                        <b-tag
                            class="table-tag table-tag-full-width"
                            :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                            size="is-medium"
                        >
                            {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                        </b-tag>
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>

        <!-- MODAL DE ASSOCIACAO -->
        <b-modal :active.sync="showModal" @fecharModal="fecharModal">
            <div class="bg">
                <TabPrecoSelectModal
                    :idCliente="$route.params.id"
                    @fecharModal="fecharModal"
                    @selected="selected"
                    v-if="modalManage == false"
                />
                <TabPrecoManageModal
                    :selected="asstabprecocliente"
                    @fecharModal="fecharModal"
                    v-else
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
import ModalVSelect from '@/components/shared/ModalVSelect.vue';
// SERVICES
import AssTabPrecoCliente from '@/services/vendas/cliente/abas/AssTabPrecoClienteService';
import TabPrecoSelectModal from '@/components/vendas/cliente/modal/TabPrecoSelectModal.vue';
import TabPrecoManageModal from '@/components/vendas/cliente/modal/TabPrecoManageModal.vue';
// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },

    components: {
        ModalVSelect,
        ContainerLoader,
        AssTabPrecoCliente,
        TabPrecoSelectModal,
        TabPrecoManageModal,
    },
    data() {
        return {
            assTabPrecoClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSTABPRECOCLIENTE'
            ),
            tabPrecoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('TABPRECO'),
            asstabprecoclientelist: [],
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'tabela-preco', width: null, sortable: true, sortFn: null },
                { key: 'datavalidade', width: null, sortable: true, sortFn: null },
                {
                    key: 'volumeminimopedido',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                { key: 'reajusteciffob', width: null, sortable: true, sortFn: null },
                { key: 'moeda', width: null, sortable: true, sortFn: null },
                { key: 'replicapda', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],

            service: new AssTabPrecoCliente(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],

            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'tabela-precos',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModal: false,
            modalCadastroTabPreco: false,
            modalManage: false,
            asstabprecoclietne: null,
            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,

            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-politica-comercial-tabela-preco'
            );
            this.permissaoCadastroTabPreco = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-tabelapreco'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-politica-comercial-tabela-preco'
            );
            this.permissaoCadastroTabPreco = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-tabelapreco'
            );
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }

        this.permissaoVincular = this.permissao.create && !this.assTabPrecoClienteIntegracao;
        this.permissaoCadastrar = this.permissaoCadastroTabPreco.create && !this.tabPrecoIntegracao;
    },
    methods: {
        showMessage(type, message) {
            let data = {
                type: type,
                message: message,
            };

            this.$emit('alert', data);
        },
        loadPage(pageNumber) {
            let query = {
                page: pageNumber,
                limit: this.data.perPage,
                column: this.column,
                order: this.order,
            };

            this.$emit('load-page', query);
        },
        loadSort(field, order) {
            this.column = field;
            this.order = order;

            this.loadPage(this.data.page);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.asstabprecoclientelist = value;
                    this.isEmpty = this.asstabprecoclientelist.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as tabelas de preços.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idcliente, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    idasstabprecocliente: m.idasstabprecocliente,
                    codigo: m.tabPreco.idtabprecoerp,
                    'tabela-preco': m.tabPreco.descricao,
                    datavalidade: m.tabPreco.datavalidade,
                    volumeminimopedido: m.tabPreco.volumeminimopedido,
                    reajusteciffob: m.tabPreco.reajusteciffob,
                    moeda: m.moeda.simbolomonetario,
                    replicapda: m.replicapda,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['tabela-preco'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-ao-reativar-associacao-tabela-preco'
                    : 'msg-ao-desativar-associacao-tabela-preco';

            let tempAsstabprecocliente = {
                idasstabprecocliente: this.delete.idasstabprecocliente,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAsstabprecocliente)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-ao-reativar-associacao-tabela-preco'
                                : 'msg-ao-desativar-associacao-tabela-preco';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(asstabprecocliente) {
            if (this.isVenda) return this.service.updateSituacaoVendas(asstabprecocliente);
            else return this.service.updateSituacaoAgro(asstabprecocliente);
        },
        showModalTabPrecoNaoAsoociados() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        showModalCadastroTabPreco() {
            this.modalCadastroTabPreco = !this.modalCadastroTabPreco;
        },
        fecharModal() {
            this.showModal = false;
            this.modalManage = false;
            this.modalCadastroTabPreco = false;
            this.carregarDados();
        },
        selected(selected) {
            this.modalManage = true;
            this.asstabprecocliente = selected;
        },
        selectedEdit(selected) {
            this.modalManage = true;
            this.asstabprecocliente = selected;
            this.showModal = true;
        },
        cadastrado() {
            this.modalCadastroTabPreco = false;
            this.carregarDados();
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        },
    },
};
</script>
<style lang="scss" scoped>
.botao-acao {
    margin-top: 24px;
    width: 100%;
    height: 40px;
}

@media (max-width: 760px) {
    .search-bar {
        padding-bottom: 0.4rem;
    }
    .botao-acao {
        margin-top: 0;
    }
}
</style>
